export const SCHEDULE_AB_7_COLUMNS = {
  gridColumns: [
    {
      dataType: 'string',
      displayName: 'Legal Entity',
      propertyName: 'legalEntityId',
    },
    {
      allowedValues: ['Furniture', 'Fixture', 'Equipment', 'Collectable'],
      dataType: 'enum',
      displayName: 'Type of Furniture Asset',
      propertyName: 'typeOfFurnitureAsset',
      queryType: 'ScheduleTypeOfFurnitureAsset'
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Name',
      propertyName: 'name',
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Net Book Value',
      propertyName: 'netBookValue',
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Valuation Method',
      propertyName: 'valutationMethod',
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Current Value',
      propertyName: 'currentValue',
    },
    {
      allowedValues: null,
      dataType: 'bool',
      displayName: 'Depreciation Schedule',
      propertyName: 'depreciationSchedule',
    },
    {
      allowedValues: null,
      dataType: 'bool',
      displayName: 'Appraised in the Last Year',
      propertyName: 'appraisedInLastYear',
    },

    {
      allowedValues: ['No', 'All', 'Address', 'Name'],
      dataType: 'enum',
      displayName: 'Redact',
      propertyName: 'redact',
      queryType: 'RedactType'
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Footnote',
      propertyName: 'footnote',
    },
    {
      allowedValues: null,
      dataType: 'string',
      displayName: 'Entity Comments',
      propertyName: 'entityComments',
    },
  ],
};
